import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "message text-deemphasized" }

import RichTranslation from '@shell/components/RichTranslation.vue';
import { computed } from 'vue';


import Card from '@shell/components/Resource/Detail/Card/index.vue';
import { useI18n } from '@shell/composables/useI18n';
import { useStore } from 'vuex';
import { BLANK_CLUSTER } from '@shell/store/store-types';
import { isAdminUser } from '@shell/store/type-map';
import { DOCS_BASE } from '@shell/config/private-label';

export default /*@__PURE__*/_defineComponent({
  __name: 'ExtrasCard',
  setup(__props) {

const store = useStore();
const i18n = useI18n(store);
const isAdmin = computed(() => isAdminUser(store.getters));

const extensionsRoute = { name: 'c-cluster-uiplugins', params: { cluster: BLANK_CLUSTER } };
const extensionsDocsUrl = `${ DOCS_BASE }/integrations-in-rancher/rancher-extensions`;

const clusterToolsRoute = { name: 'c-cluster-explorer-tools' };
const clusterToolsDocsUrl = `${ DOCS_BASE }/reference-guides/rancher-cluster-tools`;

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(Card, {
    title: _unref(i18n).t('component.resource.detail.card.extrasCard.title')
  }, {
    default: _withCtx(() => [
      _createElementVNode("p", _hoisted_1, [
        _createVNode(RichTranslation, { k: "component.resource.detail.card.extrasCard.message" }, {
          extensionsLink: _withCtx(({ content }) => [
            (isAdmin.value)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 0,
                  class: "secondary text-deemphasized",
                  to: extensionsRoute
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(content), 1)
                  ]),
                  _: 2
                }, 1024))
              : (_openBlock(), _createElementBlock("a", {
                  key: 1,
                  class: "secondary text-deemphasized",
                  href: extensionsDocsUrl,
                  target: "_blank"
                }, _toDisplayString(content), 1))
          ]),
          clusterToolsLink: _withCtx(({ content }) => [
            (isAdmin.value)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 0,
                  class: "secondary-text-link",
                  to: clusterToolsRoute
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(content), 1)
                  ]),
                  _: 2
                }, 1024))
              : (_openBlock(), _createElementBlock("a", {
                  key: 1,
                  class: "secondary-text-link",
                  href: clusterToolsDocsUrl,
                  target: "_blank"
                }, _toDisplayString(content), 1))
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})